<template>
    <div v-if="items.length">
        <template v-if="hasUnavailable === true">
            <div class="row">
                <div class="col-12">

                    <div class="box">
                        <div class="title">Удалите позиции, недоступные на складе</div>

                        <div class="text mt_xs">
                            <p></p>
                        </div>

                        <button class="btn btn_lg btn_common" disabled>Оформить заказ</button>
                    </div>

                </div>
            </div>
        </template>

        <template v-if="hasUnavailable === false">
            <order-form-payer>
            </order-form-payer>
            <order-form-delivery></order-form-delivery>
            <!-- <order-form-recipient></order-form-recipient> -->
            <order-form-payment-method></order-form-payment-method>

            <div class="row form_block mt_sm">
                <div class="col-12">
                    <div class="form-group">
                        <label for="order-comment">Комментарий к заказу</label>
                        <textarea class="form-control" id="order-comment" rows="5" v-model="comment" @input.prevent="updateComment"></textarea>
                    </div>

                    <div v-if="isNaturalPerson" class="form-group mt_sm">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="agreeWithPublicOffer" name="agree_offer" :class="{ 'is-invalid': errors.agree_offer }" value=1 v-model="agree_offer" @change="updateAgreeWithOffer($event)">
                            <label class="form-check-label" for="agreeWithPublicOffer">Согласен с условиями <a href="/public-offer">Публичной оферты</a></label>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!exceededQty" class="row mt_xl">
                <div class="col-12">
                    <div class="box">
                        <div class="title">Оформите ваш заказ</div>
                        <div class="text mt_xs">
                            <p>
                                Пожалуйста, перепроверьте заказанные позиции, а также данные плательщика и получателя.
                                <br /> В случае ошибки может быть выставлен неправильный счет или заказ не будет доставлен.
                            </p>
                            <p>
                                Подготовьте необходимые документы получателя со своей стороны.
                            </p>
                        </div>
                        <button class="btn btn_lg btn_common" @click.prevent="checkForm()" :disabled="isSaving">
                                        Оформить заказ
                                    </button>
                    </div>
                </div>
            </div>
            <div v-else class="row mt_xl">
                <div class="col-12">

                    <div class="box">
                        <div class="title">Превышено максимальное количество товаров в корзине для оплаты онлайн</div>

                        <div class="text mt_xs">
                            <p>
                                Чтобы оформить заказ с <strong>оплатой онлайн</strong>, в корзине должно находиться <strong>не более 50 наименований</strong> товаров. Сейчас {{ items.length }}.
                            </p>
                        </div>

                        <button class="btn btn_lg btn_common" disabled>Оформить заказ</button>
                    </div>

                </div>
            </div>

        </template>
    </div>
</template>

<script>
// import OrderFormDelivery from './OrderFormDelivery.vue';
// import OrderFormPayer from './OrderFormPayer.vue';
// import OrderFormPaymentMethod from './OrderFormPaymentMethod.vue';
// import OrderFormReciever from './OrderFormReciever.vue';
// export default {
//     components: { OrderFormDelivery, OrderFormPayer, OrderFormPaymentMethod, OrderFormReciever },
// };

export default {
    data: function() {
        return {
            comment: null,
            agree_offer: false,
        }
    },
    methods: {
        checkForm: function(e) {
            this.$store.dispatch('order/validate', true);
        },

        updateComment(e) {
            this.$store.dispatch('order/updateComment', e.target.value);
        },

        updateAgreeWithOffer(e) {
            this.$store.dispatch('order/updateAgreeWithOffer', this.agree_offer);
        }
    },
    computed: {
        items() {
            return this.$store.state.cart.items;
        },

        hasUnavailable() {
            return this.$store.state.cart.hasUnavailable;
        },

        // Превышено максимальное количество товаров
        exceededQty() {
            return this.$store.state.order.payment.id == 3 && this.$store.state.cart.items.length > 50;
        },

        isSaving() {
            return this.$store.state.order.isSaving;
        },

        isNaturalPerson() {
            return this.$store.state.order.payer.type == 3;
        },

        errors() {
            return this.$store.state.order.errors;
        }
    },
    mounted() {}
};
</script>
